import BC from '../init';

export default BC.Methods.mobileMenu = () => {
    
    const btn = document.querySelector('.hamburger-btn');

    const toggleMenu = () => {
        document.body.classList.toggle('menu-open');
    }

    btn.addEventListener('click', toggleMenu);
};
